"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Input_InvalidNumberValue: "'{0}' is not an accepted value for Field '{1}'. This field accepts numbers only.",
                Input_NumberAriaLabel: "Number Input",
                Input_PositiveOnly: "Field '{0}'(= {1}) can only contain positive numbers.",
                Input_ValueOutOfRange: "The value is not within the range.\r\nAcceptable values are in the range {0} - {1}.",
            }
        });
        /**
         * Framework class for Number controls
         */
        var Number = /** @class */ (function (_super) {
            __extends(Number, _super);
            function Number() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(Number.prototype, "MaxValue", {
                /**
                 * The max number as a DynNumber
                 */
                get: function () {
                    if (!this._maxValue) {
                        this._maxValue = this.convertDynNumber(this.MaxValueNumber, this.WireFormat);
                    }
                    return this._maxValue;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Number.prototype, "MinValue", {
                /**
                 * The min number as a DynNumber
                 */
                get: function () {
                    if (!this._minValue) {
                        if (this.allowNegativeValue()) {
                            this._minValue = this.convertDynNumber(this.MinValueNumber, this.WireFormat);
                        }
                        else {
                            this._minValue = this.convertDynNumber("0", this.WireFormat);
                        }
                    }
                    return this._minValue;
                },
                enumerable: false,
                configurable: true
            });
            Number.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.signDisplayBackup = new Array();
                this.rotateSignBackup = new Array();
                this.CurrentSignDisplay = $dyn.observable(this.SignDisplayForEdit);
                $dyn.observe(this.CurrentSignDisplay, this._updateSignDisplay, this);
                if ($dyn.user() && $dyn.user().RegionalSettings) {
                    this._regionalSettingsObserver = $dyn.observe($dyn.user().RegionalSettings, this._regionalSettingsChanged, this);
                }
                $dyn.observe(this.RotateSign, function (value) {
                    _this.SignMultiplier(value === "Yes" ? -1 : 1);
                });
                $dyn.observe(this.SignDisplay, function (value) {
                    _this.CurrentSignDisplay(value);
                });
                $dyn.observe(this.AllowNegative, function () {
                    _this._minValue = undefined;
                });
                this.$inputElement.on("focus", $dyn.controls.Number.prototype.gotFocus);
                this.$inputElement.on("blur", $dyn.controls.Number.prototype.lostFocus);
            };
            Number.prototype.getFormattedValue = function () {
                var numberStr = "";
                if ($dyn.peek(this.IsValid) || this._lastUserValue === undefined) {
                    numberStr = this.formatValue(this._parsedValue);
                }
                else {
                    numberStr = this._lastUserValue;
                }
                return numberStr;
            };
            Number.prototype.setFormattedValue = function (userValue, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var promise;
                var logMessages = this.shouldControlLogMessage(userValue);
                this._lastUserValue = userValue;
                var newValue = this.convertDynNumber(userValue, this.UserFormat);
                var sameNumbers = false;
                if (!forceChange && newValue && (newValue.CompareToDynNumber(this._parsedValue) === 0)) {
                    sameNumbers = true;
                    // If the newValue is zero it could be blank or a zero value, some cases we need to treat these as different
                    if (newValue.IsZero()) {
                        if ($dyn.value(this.AllowBlankValue)) {
                            if (newValue.IsBlank() !== ($dyn.value(this.Value) === "")) {
                                // Set forceChange to true since we already did the comparison to this.Value
                                sameNumbers = false;
                                forceChange = true;
                            }
                        }
                        else if (this.showZeroValue() === newValue.IsBlank() && this.ChangeMode === $dyn.ui.ChangeMode.dirty) {
                            // Need to bypass the stringComparison check in setValue because with
                            // AllowBlankValue=false we will send "0" to setValue instead of blank string
                            sameNumbers = false;
                            forceChange = true;
                        }
                    }
                }
                if (forceChange || !sameNumbers || !$dyn.peek(this.IsValid)) {
                    var result = this.validateDynNumber(userValue, newValue, logMessages);
                    this._keepMessageID = result.messageID;
                    this._lastValidationResult = result.isValid;
                    if (logMessages) {
                        this.removeMessagesAsync();
                    }
                    if (result.isValid) {
                        newValue.SignMultiplier($dyn.value(this.SignMultiplier));
                        newValue.SetNumberFormat(this.WireFormat);
                        this._parsedValue = newValue;
                        if (this.ReferenceGroup && $dyn.peek(this.ReferenceGroup.isFocused)) {
                            this.ReferenceGroup.isChildDataDirty = true;
                        }
                        else {
                            var valueStr = void 0;
                            if (newValue.IsBlank() && $dyn.value(this.AllowBlankValue)) {
                                valueStr = "";
                            }
                            else {
                                valueStr = newValue.GetNumberString();
                            }
                            promise = this.setValue(valueStr, forceChange, forceCommandCall);
                        }
                    }
                    else {
                        this.IsValid(false);
                    }
                }
                if (!promise) {
                    promise = $.Deferred();
                    promise.resolve();
                }
                return promise;
            };
            /**
             * If editable put the control into edit display mode on focus
             * @param eventObject The focus event
             */
            Number.prototype.gotFocus = function (eventObject) {
                var self = $dyn.context(eventObject.currentTarget);
                if (self && $dyn.value(self.AllowEdit)) {
                    self.updatingBlock(function () {
                        var raiseChanged = false;
                        var shouldSelect = false;
                        // Save the current SignDisplay value
                        var currentSignDisplay = self.CurrentSignDisplay();
                        self.signDisplayBackup.push(currentSignDisplay);
                        if (currentSignDisplay !== $dyn.ui.SignDisplayType.Auto && currentSignDisplay !== self.SignDisplayForEdit) {
                            self.CurrentSignDisplay(self.SignDisplayForEdit);
                            raiseChanged = true;
                        }
                        var currentRotateSign = self.RotateSign();
                        self.rotateSignBackup.push(currentRotateSign);
                        if (currentRotateSign === "Yes") {
                            self.RotateSign("No");
                            // SignMultiplier is apart of the computed for formattedValue
                            // so it will cause a value changed
                            raiseChanged = false;
                            shouldSelect = true;
                        }
                        if (raiseChanged) {
                            self.formattedValue.valueChanged.raise();
                        }
                        // When the formattedValue is changed the text get unselected in IE
                        // Below code is selecting the text explicitly
                        if (raiseChanged || shouldSelect) {
                            // find the DOM object of input element
                            var el = self.$inputElement.get(0);
                            var pos = el.selectionStart;
                            // only IE has createTextRange
                            if (el.createTextRange) {
                                var r = el.createTextRange();
                                r.moveStart("character", pos);
                                r.moveEnd("character", pos - el.value.length);
                                r.select();
                            }
                        }
                    });
                }
            };
            /**
             * Take the control out of edit display mode on blur, if applicable
             * @param eventObject - The blur event
             */
            Number.prototype.lostFocus = function (eventObject) {
                var self = $dyn.context(eventObject.currentTarget);
                if (self && $dyn.value(self.AllowEdit)) {
                    self.updatingBlock(function () {
                        var raiseChanged = false;
                        var oldSignDisplay = self.CurrentSignDisplay();
                        while (self.signDisplayBackup.length > 0) {
                            oldSignDisplay = self.signDisplayBackup.pop();
                        }
                        if (self.CurrentSignDisplay() !== oldSignDisplay) {
                            self.CurrentSignDisplay(oldSignDisplay);
                            raiseChanged = true;
                        }
                        var oldRotateSign = self.RotateSign();
                        while (self.rotateSignBackup.length > 0) {
                            oldRotateSign = self.rotateSignBackup.pop();
                        }
                        if (self.RotateSign() !== oldRotateSign) {
                            self.RotateSign(oldRotateSign);
                            // SignMultiplier is apart of the computed for formattedValue
                            // so it will cause a value changed
                            raiseChanged = false;
                        }
                        if (raiseChanged) {
                            self.formattedValue.valueChanged.raise();
                        }
                    });
                }
            };
            Number.prototype.displayedValue = function () {
                var displayedValue;
                if (this.$inputElement && this.$inputElement[0]) {
                    displayedValue = this.$inputElement[0].value;
                }
                else {
                    // this is the case for all the xLabel Types
                    var value_1 = $dyn.value(this.Value);
                    displayedValue = typeof value_1 === "number" ? value_1.toString() : value_1;
                }
                return displayedValue;
            };
            Number.prototype.isMandatoryMet = function () {
                var met = true;
                if ($dyn.value(this.formattedValue) === null ||
                    $dyn.value(this.formattedValue) === "" ||
                    // tslint:disable-next-line:triple-equals
                    $dyn.value(this.formattedValue) == 0 // doing this since 0 == "0" and 0 == "0.00" are true
                ) {
                    met = false;
                }
                return met;
            };
            Number.prototype.dispose = function () {
                this.$inputElement.off("focus", $dyn.controls.Number.prototype.gotFocus);
                this.$inputElement.off("blur", $dyn.controls.Number.prototype.lostFocus);
                if (this._regionalSettingsObserver) {
                    this._regionalSettingsObserver.dispose();
                }
                _super.prototype.dispose.call(this);
            };
            Number.prototype.compareToParsedValue = function (newValue) {
                var areEqual = false;
                if (this._parsedValue) {
                    // newValue is expected to be in the wire format
                    var newDynNumber = this.convertDynNumber(newValue, this.WireFormat);
                    if (this._parsedValue.CompareToDynNumber(newDynNumber) === 0) {
                        areEqual = true;
                        if (newDynNumber.IsBlank() !== this._parsedValue.IsBlank()) {
                            areEqual = false;
                        }
                    }
                }
                return areEqual;
            };
            Number.prototype.updateParsedValue = function (newValue) {
                if (this._parsedValue) {
                    this._parsedValue.SetValue(newValue);
                }
                else {
                    this._parsedValue = this.convertDynNumber(newValue, this.WireFormat);
                }
            };
            Number.prototype.parsedValueToString = function () {
                var numberString = "";
                if (this._parsedValue !== undefined) {
                    numberString = this._parsedValue.GetNumberString();
                }
                return numberString;
            };
            Number.prototype.applyParameters = function (data) {
                _super.prototype.applyParameters.call(this, data);
                // After we have applied parameters, but before initializing the rest of the
                // control we want to add the custom culture so it is available for any logic
                // that needs it.
                var userFormat = {};
                $.extend(true, userFormat, Globalize.culture().numberFormat);
                this.UserFormat = userFormat;
                this.WireFormat = {
                    "+": "",
                    ",": "",
                    "-": "-",
                    ".": ".",
                    decimals: 2,
                    groupSizes: [3],
                    IsWire: true,
                    pattern: ["-n"],
                };
            };
            Number.prototype.lastValidFormattedValue = function () {
                var dynValue = this.convertDynNumber($dyn.value(this.Value), this.WireFormat);
                return this.formatValue(dynValue);
            };
            Number.prototype._formatAsDisplayValue = function (rawValue) {
                // rawValue is exptected to be in the wire format
                var dynValue = this.convertDynNumber(rawValue, this.WireFormat);
                return this.formatValue(dynValue);
            };
            Number.prototype.updateLastUserValue = function (newValue) {
                this._lastUserValue = typeof newValue === "number" ? newValue.toString() : newValue;
            };
            /**
             * Update the display properties when the regional settings change
             */
            Number.prototype._regionalSettingsChanged = function () {
                this._updateSignDisplay($dyn.value(this.CurrentSignDisplay));
            };
            /**
             * Determines if we should show a zero value or not
             * @returns Whether or not we show a zero value
             */
            Number.prototype.showZeroValue = function () {
                var showZeroText = $dyn.value(this.ShowZero);
                var showZeroBool = (showZeroText === $dyn.ui.autoValue);
                if (!showZeroBool) {
                    showZeroBool = $dyn.util.stringToBoolean(showZeroText);
                }
                return showZeroBool;
            };
            /**
             * Determines if we allow a negative value or not
             * @returns Whether or not we allow a negative value
             */
            Number.prototype.allowNegativeValue = function () {
                var allowNegativeText = $dyn.value(this.AllowNegative);
                var allowNegativeBool = (allowNegativeText === $dyn.ui.autoValue);
                if (!allowNegativeBool) {
                    allowNegativeBool = $dyn.util.stringToBoolean(allowNegativeText);
                }
                return allowNegativeBool;
            };
            /**
             * Converts a number string into a DynNumber
             * @param value The number string to be converted
             * @param numberFormat The format to be used on the DynNumber
             * @returns The converted DynNumber
             */
            Number.prototype.convertDynNumber = function (value, numberFormat) {
                var dynValue;
                if (value === undefined || value === null) {
                    value = "";
                }
                if (numberFormat) {
                    dynValue = new $dyn.util.Numbers.DynNumber(this.IgnoreDecimal, numberFormat);
                }
                else {
                    dynValue = new $dyn.util.Numbers.DynNumber(this.IgnoreDecimal);
                }
                dynValue.SetValue(value);
                return dynValue;
            };
            /**
             * Verifies the conversion to DynNumber was successful and constructs the return object.
             * @param valueStr The number string that was used in the conversion
             * @param dynNumber The converted DynNumber
             * @param logMessages Flag based on which messages will be logged to message bar and control.
             * @returns An object containing whether the conversion was valid and the DynNumber
             */
            Number.prototype.validateDynNumber = function (valueStr, dynNumber, logMessages) {
                if (logMessages === void 0) { logMessages = false; }
                var isValid = false;
                var messageID = null;
                if (dynNumber) {
                    if (dynNumber.IsNaN()) {
                        if (logMessages) {
                            messageID = this.warn($dyn.format($dyn.label("Input_InvalidNumberValue"), valueStr, this.Label ? this.Label : this.Name), "Input_InvalidNumberValue");
                        }
                    }
                    else if (!this.allowNegativeValue() && dynNumber.IsNegative()) {
                        if (logMessages) {
                            messageID = this.warn($dyn.format($dyn.label("Input_PositiveOnly"), this.Label ? this.Label : this.Name, valueStr), "Input_PositiveOnly");
                        }
                    }
                    else if (!this.checkRange(dynNumber)) {
                        if (logMessages) {
                            messageID = this.warn($dyn.format($dyn.label("Input_ValueOutOfRange"), this.formatValue(this.MinValue), this.formatValue(this.MaxValue)), "Input_ValueOutOfRange");
                        }
                    }
                    else {
                        isValid = true;
                    }
                }
                return { isValid: isValid, value: dynNumber, messageID: messageID };
            };
            /**
             * Format the specified DynNumber with the controls properties
             * @param dynValue The supplied DynNumber
             * @returns The formatted number string
             */
            Number.prototype.formatValue = function (dynValue) {
                var numberStr = "";
                if (dynValue) {
                    if ((!this.showZeroValue() || $dyn.value(this.AllowBlankValue)) && dynValue.IsBlank()) {
                        return numberStr;
                    }
                    if (!dynValue.IsNaN() && (!dynValue.IsZero() || this.showZeroValue())) {
                        var oldNumberFormat = dynValue.GetNumberFormat();
                        var isCorrection = $dyn.value(this.IsCorrection);
                        var signMultiplier = $dyn.value(this.SignMultiplier);
                        dynValue.SignMultiplier(signMultiplier);
                        dynValue.ShowPositive(isCorrection);
                        if (this.UserFormat) {
                            dynValue.SetNumberFormat(this.UserFormat);
                        }
                        /*==============================================================================================================================*/
                        // Corrections/Negative Displacement/(Storno)
                        //
                        // A Grid column using DisplaceNegative is intended to give the perception of both a debit and credit column,
                        // even though it is a single field. Instances of these columns are also typically SignDisplay=None, because the left/right
                        // justification is sufficient to indicate positive/negative. When the control SupportsCorrection this behavior is enforced.
                        //
                        // The IsCorrection flag on the control indicates if the bound value represents a correction. It is a virtualized property that
                        // varies for every row instance.
                        //
                        // When IsCorrection is true there are two different scenario to consider:
                        //
                        // a. DisplaceNegative=Auto
                        //    In this scenario the real control value is presented as-is with the only modification being that positive values explicitly
                        //    show the '+' sign. This behavior is meant to better indicate to the user that the value represents a correction. For negative
                        //    numbers the '-' sign is shown as usual with no additional indications. Typically in the grid both the debit and credit rows
                        //    appear adjacent and so it is easy to recognize the pairing and so only a special '+' indicator on the positive value is necessary.
                        //
                        // b. DisplaceNegative!=Auto
                        //    For this scenario the behavior of the control changes significantly. When IsCorrection is true the values swap sides in the
                        //    displacement, and they appear with a '-' negative. (SignDisplay is already interpreted to be None so there is never a case where '--' appears.)
                        //    The intent of this view is to represent a debit instead as a 'negative credit', and likewise a credit as a 'negative debit' because it
                        //    was entered as a correction.
                        //
                        // As a consequence of this design fields that SupportsCorrection and use DisplaceNegative are not editable. It would be unclear to the user what sign to use
                        // when editing the backing data.
                        /*===============================================================================================================================*/
                        var hasDisplaceNegativeFormatting = ($dyn.value(this.DisplaceNegative) !== $dyn.ui.autoValue && this.isInGrid() === true);
                        var hasDisplaceCorrectionFormatting = hasDisplaceNegativeFormatting && isCorrection;
                        if ($dyn.value(this.SupportsCorrection) && hasDisplaceNegativeFormatting) {
                            dynValue.ShowPositive(false); // The displace negative views never shows an explicit positive for corrections, by design.
                            if (hasDisplaceCorrectionFormatting) {
                                if (!dynValue.IsNegative()) {
                                    dynValue.SignMultiplier(signMultiplier * -1); // Manipulate the SignMultiplier to ensure a '-' is shown.
                                }
                            }
                            else if (dynValue.IsNegative()) {
                                dynValue.SignMultiplier(signMultiplier * -1); // Manipulate the SignMultipler to ensure the sign is hidden. (This asserts SignDisplay=None when using DisplaceNegative.)
                            }
                        }
                        numberStr = dynValue.GetValue();
                        // reset the number format to what it was before we set it to the UserFormat
                        dynValue.SetNumberFormat(oldNumberFormat);
                        var displayAmount = "";
                        if (hasDisplaceNegativeFormatting && dynValue.IsNegative() !== (!hasDisplaceCorrectionFormatting)) {
                            displayAmount = parseInt($dyn.value(this.DisplaceNegative), 10) + "ex";
                        }
                        // TODO: Research if there is an RTL issue here.
                        this.$inputElement.css("padding-right", displayAmount);
                    }
                }
                return numberStr;
            };
            /**
             * Check if the specified DynNumber is within the Min/Max value specified on control
             * @param dynNumber The DynNumber to check the range on
             * @returns True if within range, otherwise false
             */
            Number.prototype.checkRange = function (dynNumber) {
                var valid = true;
                var compare = dynNumber.CompareToDynNumber(this.MaxValue);
                if (compare > 0) {
                    // Value is larger than MaxValue
                    valid = false;
                }
                else {
                    compare = dynNumber.CompareToDynNumber(this.MinValue);
                    if (compare < 0) {
                        // Value is smaller than MinValue
                        valid = false;
                    }
                }
                return valid;
            };
            /**
             * Update the format the control uses when the sign display changes
             * @param value The new sign display value
             */
            Number.prototype._updateSignDisplay = function (value) {
                var signDisplay;
                // When Corrections are supported and DisplaceNegative is being used the signs must be allowed, however in this mode
                // they will be strictly controlled by DisplaceNegatve/IsCorrection logic in formatValue, not by the actual value's sign.
                if ($dyn.value(this.SupportsCorrection) && $dyn.value(this.DisplaceNegative) !== $dyn.ui.autoValue) {
                    value = $dyn.ui.SignDisplayType.Auto;
                }
                switch (value) {
                    case $dyn.ui.SignDisplayType.None:
                        signDisplay = "n";
                        break;
                    case $dyn.ui.SignDisplayType.Prefixed:
                        signDisplay = "-n";
                        break;
                    case $dyn.ui.SignDisplayType.Suffixed:
                        signDisplay = "n-";
                        break;
                    case $dyn.ui.SignDisplayType.Parentheses:
                        signDisplay = "(n)";
                        break;
                    case $dyn.ui.SignDisplayType.Auto:
                    default:
                        signDisplay = Globalize.culture().numberFormat.pattern[0];
                        break;
                }
                this.UserFormat.pattern = [signDisplay];
            };
            return Number;
        }(controls.BaseInput));
        controls.Number = Number;
        Number.prototype.IsNumber = true;
        Number.prototype.DisplaceNegative = $dyn.ui.autoValue;
        Number.prototype.SignDisplay = $dyn.ui.SignDisplayType.Auto;
        Number.prototype.AllowBlankValue = false;
        Number.prototype.Alignment = $dyn.ui.autoValue;
        Number.prototype.SupportsCorrection = false;
        Number.prototype.MaxValueNumber = "1";
        Number.prototype.MinValueNumber = "1";
        // tslint:disable-next-line:no-string-literal
        Number.prototype["UserFriendlyTypeName"] = "";
        // tslint:disable-next-line:no-string-literal
        Number.prototype["IgnoreDecimal"] = true;
        // tslint:disable-next-line:no-string-literal
        Number.prototype["SignDisplayForEdit"] = $dyn.ui.SignDisplayType.Prefixed;
        $dyn.ui.addObservablePropertiesToPrototype(Number.prototype, {
            AllowNegative: $dyn.ui.autoValue,
            RotateSign: $dyn.ui.autoValue,
            ShowZero: $dyn.ui.autoValue,
            SignMultiplier: 1,
        });
        $dyn.ui.addPropertiesToPrototype(Number.prototype, {
            IsCorrection: { defaultValue: false, observable: true },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Number.js.map
